/**
 * This is the actual main file of the project. This file is Javascript instead of Typescript to make it easier for parcel.
 *
 * If you want to upgrade to parcel 2 feel free to suffer through getting handlebars to work :D
 *
 * You should not need to edit this file
 */
import './scripts/main'
